import preparedReducer from './reducer';
import { requestNotebookNote, requestShiftNote, requestNotebookNotes } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'notebookNotes';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestNotebookNote,
  requestNotebookNotes,
  requestShiftNote,
};

export const selectNotebookNote = (notebookNoteID) => (state) =>
  state.notebookNotes.info[notebookNoteID] || {};
